module.exports = __webpack_public_path__ + "img/golf_title.6140864b.png";